export default "__VITE_ASSET__DWmHFrr$__"